import dayjs from 'dayjs'
import {create} from 'zustand'
import {EventInteractionArgs} from 'react-big-calendar/lib/addons/dragAndDrop'
import {
    AgendaEventAbsence,
    AgendaEventAppointment,
    AgendaEventStatus,
    AgendaEventType,
    AgendaEventUnavailability
} from '@/features/agenda/types'

type AgendaCalendarStore = {
    appointments: AgendaEventAppointment[]
    blockouts: AgendaEventAbsence[]
    unavailabilities: AgendaEventUnavailability[]
    statusFilter: AgendaEventStatus | null
    setAppointments: (appointments: AgendaEventAppointment[]) => void
    setBlockouts: (blockouts: AgendaEventAbsence[]) => void
    setUnavailabilities: (unavailabilities: AgendaEventUnavailability[]) => void
    moveEvent: (event: EventInteractionArgs<AgendaEventType>) => void
    resizeEvent: (event: EventInteractionArgs<AgendaEventType>) => void
    resetCalendar: () => void
    setStatusFilter: (statusFilter: AgendaEventStatus | null) => void
}

export const useAgendaCalendarStore = create<AgendaCalendarStore>()(set => ({
    appointments: [],
    blockouts: [],
    unavailabilities: [],
    statusFilter: null,
    setAppointments: appointments =>
        set({
            appointments: appointments.map(appointment => ({
                ...appointment,
                start: appointment.time
                    ? dayjs(appointment.start).toDate()
                    : dayjs(appointment.start).set('hour', 8).toDate(),
                end: appointment.time
                    ? dayjs(appointment.end).toDate()
                    : dayjs(appointment.end)
                          .set('hour', 8)
                          .add(appointment.duration ?? 0, 'minutes')
                          .toDate()
            }))
        }),
    setBlockouts: blockouts => set({blockouts}),
    setUnavailabilities: unavailabilities => set({unavailabilities}),
    setStatusFilter: statusFilter => set({statusFilter}),
    moveEvent: ({event, start, end}) =>
        set(store => {
            return {
                appointments: store.appointments.map(item =>
                    item.id == event.id
                        ? {
                              ...item,
                              start: dayjs(start).toDate(),
                              end: dayjs(end).toDate()
                          }
                        : item
                )
            }
        }),
    resizeEvent: ({event, start, end}) =>
        set(store => {
            return {
                appointments: store.appointments.map(item =>
                    item.id == event.id
                        ? {
                              ...item,
                              start: dayjs(start).toDate(),
                              end: dayjs(end).toDate()
                          }
                        : item
                )
            }
        }),
    resetCalendar: () => set({appointments: [], blockouts: [], unavailabilities: []})
}))
